import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <h1 className="select-none font-comic text-8xl font-black text-background-200 md:text-[12rem]">
        404
      </h1>
      <h2 className="mt-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
        页面走丢了，就像追更追到断更一样难受
      </h2>
      <p className="mt-3 text-sm text-foreground-600">
        你访问的地址 <span className="font-mono text-foreground-900">{location.pathname}</span> 不存在，去看看其他漫画吧
      </p>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-6 py-3 text-sm font-bold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-book-2-line"></i>
          浏览漫画大全
        </Link>
      </div>
    </div>
  );
}